export const MUT_SET_APPLICATION_REF = 'MUT_SET_APPLICATION_REF';
export const MUT_SET_CART_REF = 'MUT_SET_CART_REF';
export const MUT_SET_PAYMENT_SESSION_ID = 'MUT_SET_PAYMENT_SESSION_ID';
export const MUT_SET_PAYMENT_TYPE = 'MUT_SET_PAYMENT_TYPE';
export const MUT_SET_PAYMENT_REF = 'MUT_SET_PAYMENT_REF';
export const MUT_RESET = 'MUT_RESET';
